import React, { useEffect } from 'react';
import './successpopup.css';
import Success from '../../../../../assets/images/im_Success.png';

const ShortlistSuccessPopup = ({ popupVisible, closePopup }) => {
  useEffect(() => {
    let timer;
    if (popupVisible) {
      timer = setTimeout(() => {
        closePopup();
      }, 1500);
    }
    return () => clearTimeout(timer);
  }, [popupVisible, closePopup]);

  return popupVisible ? (
    <div className="profile-success-popup-overlay">
      <div className="profile-success-popup-content">
        <img src={Success} alt="success logo" className="profile-success-logo" />
        <h3>Profile has been Saved In Folder</h3>
      </div>
    </div>
  ) : null;
};

export default ShortlistSuccessPopup;
